import styled from 'styled-components'

import { mainColors, semanticColors } from '@avantstay/backoffice-core'

export const Label = styled.label`
  background-color: ${semanticColors.failureMedium};
  color: ${mainColors.white};
  padding: 5px;
  margin-left: 5px;
  border-radius: 5px;
  font-size: 10px;
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: center;
`
